import { resolveComponent as c, openBlock as d, createElementBlock as h, normalizeClass as v, withModifiers as o, createVNode as b, withCtx as w, createElementVNode as p, renderSlot as S, normalizeProps as K, guardReactiveProps as I, createTextVNode as u, toDisplayString as m, createCommentVNode as y, Fragment as T, renderList as q, createBlock as k, withDirectives as B, vShow as M, withKeys as n } from "vue";
import x from "./design-system.es146.js";
import C from "./design-system.es298.js";
import R from "./design-system.es299.js";
import D from "./design-system.es58.js";
import U from "./design-system.es45.js";
import A from "./design-system.es51.js";
/* empty css                    */
import E from "./design-system.es128.js";
import N from "./design-system.es95.js";
import z from "./design-system.es80.js";
import F from "./design-system.es116.js";
/* empty css                    */
/* empty css                    */
const H = {
  name: "DsMultiselect",
  components: {
    Icon: D,
    Chip: U,
    Dropdown: A,
    Spinner: N,
    MultiselectMenu: z
  },
  mixins: [R],
  props: {
    /**
     * Adds a add button to your multiselect
     */
    allowAdd: Boolean,
    /**
     * The text shown when add button is shown in multiselect (when allowAdd is true)
     */
    addText: String,
    /**
     * Show supplemental text under the option label (when helpText value is present in option)
     */
    helpText: Boolean,
    /**
     * Property for helpText option if not the default of "helpText"
     */
    helpTextProp: {
      type: String,
      default: "helpText"
    },
    /**
     * When true it allows for categories within the multiselect
     */
    categorized: Boolean,
    /**
     * Only bind the value
     */
    bindValueOnly: Boolean,
    /**
     * Label for categories when categorized is true
     */
    categoriesLabel: String,
    /**
     * Force the error state to show if parent is controlling it
     */
    forceInvalid: Boolean,
    /**
     * Limit of selectable items in the multiselect
     */
    limit: {
      type: Number,
      default: 99999
    },
    /**
     * Displays spinner if component is loading
     */
    loading: Boolean,
    /**
     * Ability to select multiple items in your dropdown
     */
    multiple: Boolean,
    /**
     * Options for the multiselect
     */
    options: {
      type: Array,
      default: () => []
    },
    /**
     * Placeholder to show when nothing is selected
     */
    placeholder: String,
    /**
     * Allow searchability of the multiselect
     */
    searchable: Boolean,
    /**
     * Show blank menu option
     */
    showBlank: Boolean,
    /**
     * Show search icon on a searchable multiselect
     */
    showSearchIcon: Boolean,
    /**
     * value of the multiselect
     */
    modelValue: [Object, Array, String, Number],
    /**
     * Label if not the default of "label"
     */
    labelProp: {
      type: String,
      default: "label"
    },
    /**
     * Value if not the default of "value"
     */
    valueProp: {
      type: String,
      default: "value"
    },
    /**
     * Option property for disabled option if not the default of "disabledOption"
     */
    disabledOptionProp: {
      type: String,
      default: "disabledOption"
    },
    /**
     * Option property to show an option modifier if present
     */
    showOptionModifierProp: {
      type: String,
      default: "showOptionModifier"
    },
    /**
     * Text to display where there are no results
     */
    noResultsLabel: String,
    /**
     * Required field for validation purposes
     */
    required: Boolean,
    /**
     * Controls visualization of rendering form validation error states
     */
    submitted: Boolean,
    /**
     * Pin the bottom of the menu to the bottom of the viewport for really long menus
     */
    pinBottom: Boolean,
    /**
     * Prevents the user from changing the selection
     */
    readonly: Boolean,
    /**
     * Semantic description of field for autocompletion in browsers
     */
    autocomplete: {
      type: String,
      default: "nofill"
    }
  },
  emits: [
    "add",
    "blur",
    "category-view",
    "select-category",
    "update-search",
    "update:modelValue"
  ],
  setup() {
    const t = F(), { isRtl: e } = x();
    return { i18n: t, isRtl: e };
  },
  data() {
    return {
      active: !1,
      closeOnBodyClick: !0,
      hasLoaded: !1,
      search: ""
    };
  },
  computed: {
    error() {
      return this.forceInvalid || this.required && this.submitted && !this.hasSelection;
    },
    filter() {
      return this.searchable ? this.search : "";
    },
    hasSelection() {
      const {
        selection: t,
        bindValueOnly: e,
        multiple: r
      } = this;
      return e && !r && t !== void 0 && t !== null || r && t && t.length ? !0 : !!(t && Object.keys(t).length);
    },
    searchableMultiselectActive() {
      return this.showSearchIcon && this.active;
    },
    selectedLabel() {
      const {
        selection: t,
        multiple: e,
        searchable: r,
        placeholder: s,
        labelProp: a,
        helpTextProp: l
      } = this;
      return e && !r ? s : this.hasHelpText(t) ? t && t[a] ? `${t[a]} (${t[l]})` : "" : t && t[a] || "";
    },
    showNoResults() {
      return this.searchable && this.options.length === 0 && !this.loading && this.hasLoaded && this.search !== "";
    },
    visibleOptions() {
      return this.multiple && this.selection ? this.selection.slice(0, this.limit) : [];
    },
    tabIndex() {
      return this.readonly ? -1 : 0;
    },
    flattenedOptions() {
      return this.options.reduce((t, e) => (e.groups ? e.groups.forEach(({ options: r = [] }) => {
        r.forEach((s) => {
          t.push(s);
        });
      }) : e.options ? e.options.forEach((r) => {
        t.push(r);
      }) : e.category ? t.push(e.category) : t.push(e), t), []);
    },
    selection() {
      const {
        modelValue: t,
        bindValueOnly: e,
        multiple: r,
        valueProp: s,
        flattenedOptions: a
      } = this;
      return e ? t ? r ? a.filter((l) => t.includes(l[s])) || [] : a.find((l) => t === l[s]) || null : r ? [] : null : r ? [...t] : t || {};
    }
  },
  watch: {
    loading(t, e) {
      this.hasLoaded = e && !t;
    },
    visibleOptions: {
      handler() {
        this.$refs.dropdown.schedulePopper();
      },
      deep: !0
    }
  },
  methods: {
    hasHelpText(t) {
      return !!(this.helpText && t && t[this.helpTextProp]);
    },
    add() {
      this.$emit("add", this.filter), this.active = !1;
    },
    activate() {
      this.readonly || (this.active = !0, this.$refs.input.focus());
    },
    arrowLeft() {
      this.isRtl ? this.$refs.dropdownMenu.arrowForward() : this.$refs.dropdownMenu.arrowBack();
    },
    arrowRight() {
      this.isRtl ? this.$refs.dropdownMenu.arrowBack() : this.$refs.dropdownMenu.arrowForward();
    },
    blur(t) {
      this.deactivate(), this.$emit("blur", t);
    },
    categorySelected(t) {
      this.$emit("select-category", t), this.deactivate();
    },
    categoryView(t) {
      this.$emit("category-view", t);
    },
    deactivate() {
      this.active = !1, this.dropdownKeys_resetPointer(), this.$refs.input.blur(), this.search = "", this.$refs.dropdownMenu.backToCategory();
    },
    updateSelection(t) {
      const {
        bindValueOnly: e,
        multiple: r,
        valueProp: s,
        modelValue: a
      } = this;
      let l;
      e && t ? l = r ? t.map((g) => g[s]) : t[s] : l = t, C(l, a) || this.$emit("update:modelValue", l);
    },
    handleSelection(t) {
      var e;
      this.updateSelection(t), (!this.multiple || ((e = this.selection) == null ? void 0 : e.length) === this.limit) && this.deactivate(), this.search = "";
    },
    onEnter(t) {
      this.$refs.dropdownMenu.onEnter(t);
    },
    removeOption(t) {
      if (this.readonly)
        return;
      const e = this.selection.filter((r, s) => s !== t);
      this.updateSelection(e);
    },
    removeLast() {
      this.search.length === 0 && this.multiple && this.selection.length > 0 && this.removeOption(this.selection.length - 1);
    },
    // TODO: Convert to controlled to avoid this being used by refs
    toggle() {
      this.active = !this.active;
    },
    updateSearch(t) {
      this.search = t, this.$emit("update-search", t);
    },
    updateVisibleOptions(t) {
      this.dropdownKeys_optionsModel = t;
    }
  }
}, j = { class: "input-container" }, G = {
  ref: "multiTag",
  class: "multiselect-tags"
}, J = { key: 0 }, Q = { key: 0 }, W = { class: "input-search" }, X = ["autocomplete", "tabindex", "value", "required"], Y = {
  key: 1,
  class: "multiselect-single"
}, Z = ["tabindex", "value", "required"], _ = {
  key: 0,
  class: "selected-label"
}, $ = { class: "input-chevron" }, ee = ["value", "required"], te = {
  key: 0,
  class: "no-results"
}, le = {
  key: 0,
  class: "assistive-text"
};
function re(t, e, r, s, a, l) {
  const g = c("Chip"), V = c("Icon"), L = c("Spinner"), O = c("MultiselectMenu"), P = c("Dropdown");
  return d(), h("div", {
    class: v(["multiselect", {
      active: a.active,
      searchable: r.searchable,
      error: l.error,
      readonly: r.readonly,
      multiple: r.multiple
    }]),
    onMousedown: e[20] || (e[20] = o((...i) => l.activate && l.activate(...i), ["stop", "prevent"]))
  }, [
    b(P, {
      ref: "dropdown",
      legacy: "",
      "is-open": a.active,
      "small-inline": r.searchable,
      "pin-bottom": r.pinBottom,
      onClose: l.deactivate
    }, {
      menu: w(() => [
        p("div", null, [
          b(O, {
            ref: "dropdownMenu",
            pointer: t.dropdownKeys_pointer,
            "onUpdate:pointer": e[19] || (e[19] = (i) => t.dropdownKeys_pointer = i),
            "model-value": l.selection,
            "add-text": r.addText,
            "allow-add": r.allowAdd,
            "value-prop": r.valueProp,
            "label-prop": r.labelProp,
            "disabled-option-prop": r.disabledOptionProp,
            "show-option-modifier-prop": r.showOptionModifierProp,
            options: r.options,
            categorized: r.categorized,
            "categories-label": r.categoriesLabel,
            filter: l.filter,
            multiple: r.multiple,
            "show-blank": r.showBlank,
            "help-text": r.helpText,
            "help-text-prop": r.helpTextProp,
            limit: r.limit,
            "show-empty-options-label": !r.searchable,
            onAdd: l.add,
            onSelectCategory: l.categorySelected,
            onUpdateVisibleOptions: l.updateVisibleOptions,
            onCategoryView: l.categoryView,
            "onUpdate:modelValue": l.handleSelection
          }, {
            optionModifier: w(() => [
              S(t.$slots, "optionModifier", {}, void 0, !0)
            ]),
            option: w((i) => [
              S(t.$slots, "option", K(I(i)), void 0, !0)
            ]),
            _: 3
          }, 8, ["pointer", "model-value", "add-text", "allow-add", "value-prop", "label-prop", "disabled-option-prop", "show-option-modifier-prop", "options", "categorized", "categories-label", "filter", "multiple", "show-blank", "help-text", "help-text-prop", "limit", "show-empty-options-label", "onAdd", "onSelectCategory", "onUpdateVisibleOptions", "onCategoryView", "onUpdate:modelValue"]),
          e[30] || (e[30] = u()),
          l.showNoResults ? (d(), h("div", te, m(r.noResultsLabel || s.i18n.messages["select.empty.results"]), 1)) : y("", !0)
        ])
      ]),
      default: w(() => [
        p("div", j, [
          p("div", G, [
            (d(!0), h(T, null, q(l.visibleOptions, (i, f) => S(t.$slots, "selection", {
              option: i,
              index: f,
              remove: () => l.removeOption(f)
            }, () => [
              r.readonly ? (d(), k(g, {
                key: `reaonly-${f}`
              }, {
                default: w(() => [
                  u(m(i[r.labelProp]) + " ", 1),
                  l.hasHelpText(i) ? (d(), h("em", J, "(" + m(i[r.helpTextProp]) + ")", 1)) : y("", !0)
                ]),
                _: 2
              }, 1024)) : (d(), k(g, {
                key: `removable-${f}`,
                onRemove: (ie) => l.removeOption(f)
              }, {
                default: w(() => [
                  u(m(i[r.labelProp]) + " ", 1),
                  l.hasHelpText(i) ? (d(), h("em", Q, "(" + m(i[r.helpTextProp]) + ")", 1)) : y("", !0)
                ]),
                _: 2
              }, 1032, ["onRemove"]))
            ], !0)), 256)),
            e[24] || (e[24] = u()),
            B(p("div", W, [
              B(b(V, { name: "search" }, null, 512), [
                [M, r.searchable]
              ])
            ], 512), [
              [M, l.searchableMultiselectActive]
            ]),
            e[25] || (e[25] = u()),
            r.searchable ? (d(), h("span", {
              key: 0,
              class: v(["input-span", { showSearchIcon: r.showSearchIcon }])
            }, [
              p("input", {
                ref: "input",
                type: "search",
                class: "search-input",
                autocomplete: r.autocomplete,
                tabindex: l.tabIndex,
                value: a.active ? a.search : l.selectedLabel,
                required: r.required,
                onFocus: e[0] || (e[0] = o((...i) => l.activate && l.activate(...i), ["stop", "prevent"])),
                onKeydown: [
                  e[1] || (e[1] = n(o((...i) => t.dropdownKeys_arrowUp && t.dropdownKeys_arrowUp(...i), ["prevent"]), ["up"])),
                  e[2] || (e[2] = n(o((...i) => t.dropdownKeys_arrowDown && t.dropdownKeys_arrowDown(...i), ["prevent"]), ["down"])),
                  e[3] || (e[3] = n(o((...i) => l.arrowLeft && l.arrowLeft(...i), ["prevent"]), ["left"])),
                  e[4] || (e[4] = n(o((...i) => l.arrowRight && l.arrowRight(...i), ["prevent"]), ["right"])),
                  e[5] || (e[5] = n(o((...i) => t.dropdownKeys_enter && t.dropdownKeys_enter(...i), ["prevent", "stop", "self"]), ["enter"])),
                  e[6] || (e[6] = n(o((...i) => l.removeLast && l.removeLast(...i), ["stop"]), ["delete"])),
                  e[7] || (e[7] = n(o((...i) => l.blur && l.blur(...i), ["stop"]), ["esc"]))
                ],
                onInput: e[8] || (e[8] = (i) => l.updateSearch(i.target.value)),
                onBlur: e[9] || (e[9] = o((...i) => l.blur && l.blur(...i), ["prevent"]))
              }, null, 40, X),
              e[21] || (e[21] = u()),
              r.multiple ? (d(), h("label", {
                key: 0,
                class: v({ "pill-label": l.visibleOptions.length, required: r.required })
              }, m(r.placeholder), 3)) : (d(), h("label", {
                key: 1,
                class: v({ "static-label": l.hasSelection, required: r.required, showSearchIcon: r.showSearchIcon })
              }, m(r.placeholder), 3))
            ], 2)) : (d(), h("span", Y, [
              p("input", {
                ref: "input",
                readonly: "",
                type: "text",
                class: "focus-input",
                tabindex: l.tabIndex,
                value: l.hasSelection ? l.selectedLabel : "",
                required: r.required,
                onFocus: e[10] || (e[10] = o((...i) => l.activate && l.activate(...i), ["stop", "prevent"])),
                onKeydown: [
                  e[11] || (e[11] = n(o((...i) => t.dropdownKeys_arrowUp && t.dropdownKeys_arrowUp(...i), ["prevent"]), ["up"])),
                  e[12] || (e[12] = n(o((...i) => t.dropdownKeys_arrowDown && t.dropdownKeys_arrowDown(...i), ["prevent"]), ["down"])),
                  e[13] || (e[13] = n(o((...i) => l.arrowLeft && l.arrowLeft(...i), ["prevent"]), ["left"])),
                  e[14] || (e[14] = n(o((...i) => l.arrowRight && l.arrowRight(...i), ["prevent"]), ["right"])),
                  e[15] || (e[15] = n(o((...i) => t.dropdownKeys_enter && t.dropdownKeys_enter(...i), ["prevent", "stop", "self"]), ["enter"])),
                  e[16] || (e[16] = n(o((...i) => l.removeLast && l.removeLast(...i), ["stop"]), ["delete"])),
                  e[17] || (e[17] = n(o((...i) => l.blur && l.blur(...i), ["stop"]), ["esc"]))
                ],
                onBlur: e[18] || (e[18] = o((...i) => l.blur && l.blur(...i), ["prevent"]))
              }, null, 40, Z),
              e[22] || (e[22] = u()),
              p("label", {
                class: v({ "static-label": l.hasSelection, required: r.required, showSearchIcon: r.showSearchIcon })
              }, m(r.placeholder), 3),
              e[23] || (e[23] = u()),
              l.hasSelection ? (d(), h("span", _, m(l.selectedLabel), 1)) : y("", !0)
            ]))
          ], 512),
          e[27] || (e[27] = u()),
          p("div", $, [
            B(b(V, { name: "chevron-down" }, null, 512), [
              [M, !r.loading]
            ]),
            e[26] || (e[26] = u()),
            B(b(L, { size: 24 }, null, 512), [
              [M, r.loading]
            ])
          ]),
          e[28] || (e[28] = u()),
          p("input", {
            style: { display: "none" },
            value: l.hasSelection ? l.selectedLabel : "",
            required: r.required && !r.searchable
          }, null, 8, ee)
        ]),
        e[31] || (e[31] = u()),
        e[32] || (e[32] = u()),
        t.$slots.help ? (d(), h("div", le, [
          S(t.$slots, "help", {}, void 0, !0)
        ])) : y("", !0)
      ]),
      _: 3
    }, 8, ["is-open", "small-inline", "pin-bottom", "onClose"])
  ], 34);
}
const ye = /* @__PURE__ */ E(H, [["render", re], ["__scopeId", "data-v-de20378c"]]);
export {
  ye as default
};
//# sourceMappingURL=design-system.es79.js.map
